import { Injectable } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  CheckinCommonState,
  CheckinCommonStore,
  resetCheckinCommon,
  selectCheckinCommonState,
  setCheckinCommon,
  updateCheckinCommon,
} from '../../store';
import { CheckinCommonModel } from '../../interface/checkin-common';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';

@Injectable({
  providedIn: 'root',
})
export class CheckinCommonStoreService extends CheckinBaseClass {
  private _checkinCommon$: Observable<CheckinCommonState>;
  private _checkinCommon!: CheckinCommonState;
  public get checkinCommon() {
    return this._checkinCommon;
  }

  /** チェックイン搭乗者情報入力から遷移してきたか */
  get isCameFromPassengerInput() {
    return this.checkinCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_PASSENGER_INPUT;
  }

  /** チェックイン確認から遷移してきたか */
  get isCameFromReview() {
    return this.checkinCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_REVIEW;
  }

  /** チェックイン状況詳細から遷移してきたか */
  get isCameFromCheckinStatus() {
    return this.checkinCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_STATUS;
  }

  constructor(private _store: Store<CheckinCommonStore>) {
    super();
    this._checkinCommon$ = this._store.pipe(select(selectCheckinCommonState));
    this.subscribeService(this._checkinCommon$, (data) => {
      this._checkinCommon = data;
    });
  }

  /**
   * チェックイン共通Storeの全ての状態を取得するObservableを取得
   * @returns CprResultStoreの全ての値を取得するObservable
   */
  public getCheckinCommonState$() {
    return this._checkinCommon$;
  }

  /**
   * チェックイン共通Storeを指定された状態に上書きする
   * @param state 上書きを行うState
   */
  public setCheckinCommon(state: CheckinCommonModel) {
    this._store.dispatch(setCheckinCommon(state));
  }

  /**
   * チェックイン共通Storeの指定されたパラメータを更新する
   * @param state 更新を行うState
   */
  public updateCheckinCommon(state: CheckinCommonModel) {
    this._store.dispatch(updateCheckinCommon(state));
  }

  /**
   * チェックイン共通Storeをクリアする
   */
  public resetCheckinCommon() {
    this._store.dispatch(resetCheckinCommon());
  }

  override destroy(): void {}
}
